import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const anchorTargetDefinition: ComponentDefinition = {
  id: 'anchorTarget',
  name: 'Anchor target (ID)',
  category: 'Basic',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/anchor.svg',
  variables: {
    id: {
      displayName: 'ID',
      type: 'Text',
      defaultValue: '',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
  },
} as const;
